import { CharityApi, CharityOutreachesApi } from '@project/services';
import { CharityModelType, CharityOutreachesModelType } from './types';

export const CharityOutreachesModel = (
  data?: CharityOutreachesApi,
): CharityOutreachesModelType => ({
  id: data?.id ?? 0,
  name: data?.name ?? '',
  description: data?.description ?? '',
  featureImage: data?.feature_image ?? '',
  charities:
    data?.charities?.map((charity) => ({
      id: charity.id,
      name: charity.name,
      description: charity.description,
      featureImage: charity.feature_image,
      images: charity.images,
      videos: charity.videos,
    })) ?? [],
});

export const CharityOutreachesListModel = (
  data: CharityOutreachesApi[],
): CharityOutreachesModelType[] => {
  return data.map((item) => CharityOutreachesModel(item));
};

export const CharityModel = (data?: CharityApi): CharityModelType => ({
  id: data?.id ?? 0,
  name: data?.name ?? '',
  description: data?.description ?? '',
  featureImage: data?.feature_image ?? '',
  images: data?.images ?? [],
  videos: data?.videos ?? [],
});
